import { Text } from '@/components/common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalButton, Wrapper, WrapperText } from './styled';
import { useNavigate } from 'react-router-dom';

const ResetPassSuccessModal: React.FC<any> = ({ closeModal, email }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClose = () => {
    closeModal();
    navigate('/register?forceLogin=true');
  };

  return (
    <Wrapper>
      <WrapperText>
        <img src="/images/radio/checked.svg" alt="" width={40} height={40} />
        <Text
          color="primary"
          variant="titleModal"
          style={{
            margin: '16px auto 16px auto',
            maxWidth: '199px',
            width: '100%',
            textAlign: 'center',
            fontSize: '18px',
          }}
        >
          {t('PASSWORD_RESET')}
        </Text>
        <Text color="secondary" variant="content" size="15">
          {t('PASSWORD_RESET_CONTENT')}
        </Text>
      </WrapperText>
      <ModalButton variant="contained" color="dark" onClick={handleClose}>
        {t('SIGN_IN')}
      </ModalButton>
    </Wrapper>
  );
};

export default ResetPassSuccessModal;
